import React from "react";

export default function Electricity() {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Electricity" clip-path="url(#clip0)">
        <g id="Group 50">
          <g id="Group">
            <g id="Group_2">
              <path
                id="Vector"
                d="M112.012 401.394C104.009 393.391 93.3692 388.984 82.0532 388.984C75.3682 388.984 68.9242 390.534 63.1152 393.442C6.03222 312.568 5.83421 201.743 63.5982 120.673C66.8022 116.175 65.7542 109.931 61.2562 106.726C56.7582 103.521 50.5142 104.569 47.3092 109.067C15.4462 153.786 -0.899786 206.594 0.0382142 261.781C0.931214 314.3 17.4212 364.12 47.8022 406.413C35.7302 422.973 37.1592 446.375 52.0942 461.312C60.3542 469.571 71.2032 473.701 82.0532 473.701C92.9032 473.701 103.752 469.571 112.012 461.312C128.531 444.792 128.531 417.914 112.012 401.394ZM97.8692 447.169C89.1462 455.89 74.9572 455.89 66.2362 447.169C57.5142 438.447 57.5142 424.256 66.2362 415.535C70.4612 411.31 76.0782 408.983 82.0522 408.983C88.0262 408.983 93.6442 411.31 97.8682 415.535C106.591 424.257 106.591 438.448 97.8692 447.169Z"
                fill="#242424"
              />
            </g>
          </g>
          <g id="Group_3">
            <g id="Group_4">
              <path
                id="Vector_2"
                d="M407.962 451.145C404.731 446.669 398.481 445.661 394.002 448.896C365.414 469.553 333.277 483.238 298.483 489.571C290.421 491.039 282.199 488.878 275.926 483.644C269.698 478.448 266.127 470.814 266.127 462.701V389.403H267C278.579 389.403 288 379.983 288 368.403V351.52C321.873 338.59 346 305.764 346 267.404V220.059C362.116 215.657 374 200.896 374 183.404C374 164.147 359.597 148.2 341 145.743V83.4038C341 66.8618 327.542 53.4038 311 53.4038C294.458 53.4038 281 66.8618 281 83.4038V145.404H231V83.4038C231 66.8618 217.542 53.4038 201 53.4038C184.458 53.4038 171 66.8618 171 83.4038V145.743C152.403 148.2 138 164.146 138 183.404C138 200.896 149.884 215.657 166 220.059V267.404C166 305.764 190.127 338.59 224 351.52V368.404C224 379.984 233.421 389.404 245 389.404H246.127V462.702C246.127 476.764 252.318 489.994 263.112 499.001C271.727 506.189 282.463 510.024 293.491 510.024C296.34 510.024 299.208 509.768 302.064 509.248C339.816 502.376 374.689 487.525 405.713 465.107C410.19 461.872 411.196 455.621 407.962 451.145ZM301.001 83.4038C301.001 77.8898 305.487 73.4038 311.001 73.4038C316.515 73.4038 321.001 77.8898 321.001 83.4038V145.404H301.001V83.4038ZM191.001 83.4038C191.001 77.8898 195.487 73.4038 201.001 73.4038C206.515 73.4038 211.001 77.8898 211.001 83.4038V145.404H191.001V83.4038ZM158.001 183.404C158.001 173.479 166.076 165.404 176.001 165.404H336.001C345.926 165.404 354.001 173.479 354.001 183.404C354.001 193.329 345.926 201.404 336.001 201.404H176.001C166.076 201.404 158.001 193.329 158.001 183.404ZM186.001 267.404V221.404H326.001V267.404C326.001 306.002 294.599 337.404 256.001 337.404C217.403 337.404 186.001 306.002 186.001 267.404ZM256.38 369.404C256.296 369.402 256.213 369.391 256.129 369.391C256.045 369.391 255.962 369.402 255.878 369.404H245.003C244.449 369.404 244.001 368.955 244.001 368.404V356.602C247.928 357.128 251.933 357.404 256.001 357.404C260.069 357.404 264.074 357.128 268.001 356.602V368.404C268.001 368.955 267.553 369.404 267.001 369.404H256.38Z"
                fill="#242424"
              />
            </g>
          </g>
          <g id="Group_5">
            <g id="Group_6">
              <path
                id="Vector_3"
                d="M436.772 424.041C432.809 420.341 426.634 420.484 422.844 424.315C422.767 424.393 422.69 424.473 422.617 424.55C418.848 428.588 419.067 434.915 423.104 438.684C425.032 440.483 427.481 441.373 429.925 441.373C432.508 441.373 435.085 440.378 437.032 438.41C437.109 438.332 437.186 438.252 437.259 438.175C441.028 434.137 440.809 427.81 436.772 424.041Z"
                fill="#242424"
              />
            </g>
          </g>
          <g id="Group_7">
            <g id="Group_8">
              <path
                id="Vector_4"
                d="M511.321 238.712C506.866 177.494 480.479 119.846 437.024 76.3888C394.312 33.6738 337.256 7.52785 276.367 2.76885C216.22 -1.93415 156.359 14.3878 107.791 48.7238C103.281 51.9118 102.21 58.1528 105.398 62.6618C108.585 67.1708 114.827 68.2438 119.336 65.0548C212.209 -0.60215 342.705 10.3488 422.882 90.5308C505.739 173.392 515.758 302.067 446.703 396.491C443.443 400.949 444.414 407.205 448.872 410.466C450.652 411.768 452.719 412.395 454.768 412.395C457.849 412.395 460.889 410.976 462.848 408.297C498.516 359.523 515.732 299.297 511.321 238.712Z"
                fill="#242424"
              />
            </g>
          </g>
          <g id="Group_9">
            <g id="Group_10">
              <path
                id="Vector_5"
                d="M87.9089 77.5452C83.9859 73.6582 77.6539 73.6842 73.7659 77.6082L73.6029 77.7742C69.7149 81.6962 69.7439 88.0282 73.6659 91.9162C75.6159 93.8482 78.1609 94.8132 80.7059 94.8132C83.2789 94.8132 85.8529 93.8252 87.8089 91.8532L87.9719 91.6872C91.8599 87.7652 91.8309 81.4332 87.9089 77.5452Z"
                fill="#242424"
              />
            </g>
          </g>
          <g id="Group_11">
            <g id="Group_12">
              <path
                id="Vector_6"
                d="M278.548 263.701C276.756 260.627 273.466 258.737 269.908 258.737H262.762L275.924 242.111C279.352 237.781 278.62 231.491 274.29 228.064C269.96 224.635 263.67 225.368 260.242 229.697L234.25 262.53C231.87 265.537 231.419 269.64 233.089 273.092C234.759 276.544 238.256 278.737 242.091 278.737H252.751L240.505 300.359C237.783 305.165 239.473 311.267 244.277 313.988C245.835 314.87 247.526 315.289 249.197 315.289C252.684 315.288 256.069 313.463 257.909 310.215L278.61 273.665C280.364 270.569 280.34 266.775 278.548 263.701Z"
                fill="#242424"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="511.999" height="511.999" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
